/**
 * InkyPic Loading Spinner Component
 * Displays loading state during image processing
 */

import React from 'react';
import '../styles/LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Processing your image...' }) => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-message">{message}</p>
      <p className="loading-submessage">This may take a few seconds</p>
    </div>
  );
};

export default LoadingSpinner;
